import type { ChatMessageListResponsePage } from './chatMessageListResponsePage';

/**
 * 채팅 메시지 목록 응답 데이터
 */
export interface ChatMessageListResponse {
  code?: string;
  message?: string;
  page?: ChatMessageListResponsePage;
  success?: boolean;
}
